module.exports = __webpack_public_path__ + "img/footer_logo.9e42b1e3.png";